import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
  defaultTypography,
} from '@backstage/theme';

import NotoSansRegular from './assets/fonts/NotoSans-Regular.woff2';
import NotoSansSemiBold from './assets/fonts/NotoSans-SemiBold.woff2';
import NotoSansBold from './assets/fonts/NotoSans-Bold.woff2';

const notoSansRegular = {
  fontFamily: 'Noto Sans',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('Noto Sans'),
    url(${NotoSansRegular}) format('woff2')
  `,
};

const notoSansSemiBold = {
  fontFamily: 'Noto Sans',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 600,
  src: `
    local('Noto Sans'),
    url(${NotoSansSemiBold}) format('woff2')
  `,
};

const notoSansBold = {
  fontFamily: 'Noto Sans',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 900,
  src: `
    local('Noto Sans'),
    url(${NotoSansBold}) format('woff2')
  `,
};

export const lightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      navigation: {
        background: '#44267f',
        indicator: '#E70068',
        color: '#D6D6FF',
        selectedColor: '#FFFFFF',
      },
    },
  }),
  fontFamily: 'Noto Sans',
  typography: {
    ...defaultTypography,
    fontFamily: `"Noto Sans", Arial, sans-serif`,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '@font-face': [notoSansRegular, notoSansSemiBold, notoSansBold],
      },
    },
  },
  defaultPageTheme: 'default',
  pageTheme: {
    default: genPageTheme({
      colors: ['#E70068', '#070068'],
      shape: shapes.wave,
    }),
  },
});

export const darkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      navigation: {
        background: '#44267f',
        indicator: '#E70068',
        color: '#D6D6FF',
        selectedColor: '#FFFFFF',
      },
    },
  }),
  fontFamily: 'Noto Sans',
  typography: {
    ...defaultTypography,
    fontFamily: `"Noto Sans", Arial, sans-serif`,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '@font-face': [notoSansRegular, notoSansSemiBold],
      },
    },
  },
  defaultPageTheme: 'default',
  pageTheme: {
    default: genPageTheme({
      colors: ['#E70068', '#070068'],
      shape: shapes.wave,
    }),
  },
});
